import NotificationChannel from '../../base/enums/NotificationChannel';

const notificationChannel: NotificationChannel = {
  both: 'Beide',
  emails: 'Email',
  mobilenotifications: 'Push-Benachrichtigungen',
  none: 'None'
};

export default notificationChannel;
